import React from 'react';
import GroupBackground from '../../../../Page/Groups/GroupBackground';

class StandardGroupView extends React.Component{

  render(){
    const group = this.props.group;
    // the following line is needed for template 1
    let topMargin = group.get('id') === Page.groups.first().get('id') && FW.store.get('site').get('template_id') === 1 ? 53 : null;
    return <div
      className="fus-section fus-white-bg"
      style={{
        minHeight: group.ls('min_height'),
        paddingTop: group.getPadding(),
        marginTop: topMargin
      }}>
      <GroupBackground group={this.props.group} />
      <div className="container">
        <div className="row group-section-holder">
          {this.props.children}
        </div>
      </div>
    </div>;
  }

}

export default StandardGroupView;
